// DivergencesAlert.tsx
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { Space } from 'antd';
import React from 'react';
import { Button, Alert } from '../../../components/index';

type VehicleDivergencesAlertProps = {
  title?: string;
  description?: React.ReactNode;
  onSendEmail?: () => void | Promise<void>;
  emailDisabled?: boolean;
  extraActions?: React.ReactNode; // botões extras do lado direito
  style?: React.CSSProperties;
};

export function VehicleDivergencesAlert({
  title = 'Divergências detectadas',
  description = (
    <>
      Foram encontradas divergências entre os veículos no pátio e os
      manifestados. Isso pode impactar esta operação.
    </>
  ),
  onSendEmail,
  emailDisabled,
  extraActions,
  style,
}: VehicleDivergencesAlertProps) {
  return (
    <Alert
      type="warning"
      showIcon={false}
      style={{ boxShadow: '0 3px 6px 0 rgba(95, 123, 145, 0.2)', ...style }}
      message={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <ExclamationCircleTwoTone
                twoToneColor="#FA8C16"
                style={{ fontSize: 21, marginRight: 12 }}
              />
              <span style={{ fontSize: 16 }}>{title}</span>
            </div>

            <Space>
              {onSendEmail && (
                <Button onClick={onSendEmail} disabled={emailDisabled}>
                  Receber por e-mail
                </Button>
              )}
              {extraActions}
            </Space>
          </div>
          <span style={{ marginLeft: 33 }}>{description}</span>
        </div>
      }
    />
  );
}
